/**
 * Timeline Dot Component
 * Renders a circular green marker at significant positions in the timeline
 *
 * DESIGN SPECS:
 * - 8px diameter circle
 * - Green color: secondary.main (matching brand/Figma design)
 * - Absolute positioning within timeline column using getBoundingClientRect()
 * - z-index: 2 (above line segments)
 *
 * POSITIONING:
 * Uses absolute Y position calculated by parent component using getBoundingClientRect()
 * to account for actual DOM measurements including Stack gaps and spacing.
 *
 * USAGE:
 * <TimelineDot position={100} testIdPrefix="pdp" />
 */

import React from "react";
import { Box } from "@mui/material";
import { TIMELINE_DOT_DIAMETER, TIMELINE_LINE_WIDTH } from "./timeline-constants";

export interface TimelineDotProps {
  position: number; // Absolute Y position in pixels from top of timeline
  testIdPrefix: string;
}

const TimelineDot: React.FC<TimelineDotProps> = ({
  position,
  testIdPrefix
}) => (
  <Box
    data-testid={`${testIdPrefix}_timeline-dot`}
    sx={{
      width: `${TIMELINE_DOT_DIAMETER}px`,
      height: `${TIMELINE_DOT_DIAMETER}px`,
      borderRadius: "50%",
      backgroundColor: "secondary.main", // Green color from Figma design
      position: "absolute",
      top: `${position}px`, // Absolute position from timeline-column calculation
      left: `-${(TIMELINE_DOT_DIAMETER - TIMELINE_LINE_WIDTH) / 2}px`, // Centers dot on line
      zIndex: 2 // Above line segments
    }}
  />
);

export default TimelineDot;
